<template>
	<div class="container-fluid">
		<div>
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col col-xs-2">
							<h4 class="panel-title">
								<span class="title">Gereciamento Transferências</span>
								<br />
								<span class="navigation">Transferência > Cadastro</span>
							</h4>
						</div>
					</div>
				</div>
				<div class="card-body">
					<form name="form" @submit.prevent="onSubmit">
						<div>
							<template v-if="validation.hasError('selectedObras')">
								<InlineMessage>{{ validation.firstError('selectedObras') }}</InlineMessage>
							</template>

							<template v-if="validation.hasError('selectedFornecedor')">
								<InlineMessage>{{ validation.firstError('selectedFornecedor') }}</InlineMessage>
							</template>

							<template v-if="validation.hasError('selectedTipoTransacao')">
								<InlineMessage>{{ validation.firstError('selectedTipoTransacao') }}</InlineMessage>
							</template>

							<template v-if="validation.hasError('selectedNotaEspecie')">
								<InlineMessage>{{ validation.firstError('selectedNotaEspecie') }}</InlineMessage>
							</template>

							<template v-if="validation.hasError('transferencias.notaNumero')">
								<InlineMessage>{{ validation.firstError('transferencias.notaNumero') }}</InlineMessage>
							</template>

							<template v-if="validation.hasError('transferencias.notaSerie')">
								<InlineMessage>{{ validation.firstError('transferencias.notaSerie') }}</InlineMessage>
							</template>

							<template v-if="validation.hasError('transferencias.notaDataEmissao')">
								<InlineMessage>{{ validation.firstError('transferencias.notaDataEmissao') }}
								</InlineMessage>
							</template>

							<template v-if="validation.hasError('transferencias.notaValorDedutivel')">
								<InlineMessage>{{ validation.firstError('transferencias.notaValorDedutivel') }}
								</InlineMessage>
							</template>

						</div>

						<div class="row">
							<div class="col-md-5 mb-2">
								<label for="contrib">Contribuinte: *</label>
								<span class="p-fluid">
									<AutoComplete id="contrib" :dropdown="true" v-model="currentUser.contribuinte.nome"
										placeholder="Pesquisar" disabled>
									</AutoComplete>
								</span>
							</div>
						</div>

						<div class="row">
							<div class="col-md-3 mb-2">
								<label for="fornecedor">Fornecedor: *</label>
								<span class="p-fluid">
									<AutoComplete id="obra" v-model="selectedFornecedor" :dropdown="true"
										:suggestions="filteredFornecedor" @complete="searchFornecedor($event)"
										field="cnpjAndNomeFornecedor" placeholder="Pesquisar" :class="{
											'p-error': validation.hasError('selectedFornecedor'),
										}">
										<template #item="slotProps">
											<div class="p-fluid" style="max-width: 50vw">
												{{ slotProps.item.cnpj }} - {{ slotProps.item.nome }}
											</div>
										</template>
									</AutoComplete>
								</span>
							</div>

							<div class="col-md-3 mb-2">
								<label for="obra">Obra: *</label>
								<span class="p-fluid">
									<AutoComplete id="obra" v-model="selectedObras" :dropdown="true"
										:suggestions="filteredObras" @complete="searchObras($event)"
										field="numeroCeiAndNomeObra" placeholder="Pesquisar" :class="{
											'p-error': validation.hasError('selectedObras'),
										}">
										<template #item="slotProps">
											<div class="p-fluid" style="max-width: 50vw">
												{{ slotProps.item.numeroCei }} - {{ slotProps.item.nome }}
											</div>
										</template>
									</AutoComplete>
								</span>
							</div>

							<div v-if="selectedObras" class="col-md-2 mb-2">
								<label for="saldoDispon">Saldo Disponível:</label>
								<span class="p-fluid">
									<money id="saldoDispon" name="saldoDispon" v-model="selectedObras.saldoDisponivel"
										v-bind="money" class="p-inputtext input-right" disabled></money>
								</span>
							</div>

							<div v-if="selectedObras" class="col-md-2 mb-2">
								<label for="saldoDeduz">Saldo Deduzido:</label>
								<span class="p-fluid">
									<money id="saldoDeduz" name="saldoDeduz" v-model="selectedObras.saldoDeduzido"
										v-bind="money" class="p-inputtext input-right" disabled></money>
								</span>
							</div>
						</div>

						<div class="row">
							<div class="col-md-3 mb-2">
								<label for="tipoTransacao">Tipo De Transação: *</label>
								<span class="p-fluid">
									<Dropdown @change="alterarKeyNotaEspecie()" id="tipoTrasacao"
										v-model="selectedTipoTransacao" :options="tiposTransacao" optionLabel="name"
										placeholder="Selecione um Tipo de Transação" :class="{
											'p-error': validation.hasError('selectedTipoTransacao'),
										}" />
								</span>
							</div>

							<div class="col-md-3 mb-2">
								<label for="especieNota">Espécie Nota: *</label>
								<span class="p-fluid">
									<Dropdown id="especieNota" v-model="selectedNotaEspecie" :options="notasEspecie"
										optionLabel="name" placeholder="Selecione um Nota Espécie" :class="{
											'p-error': validation.hasError('selectedNotaEspecie'),
										}" />
								</span>
							</div>

							<div v-if="selectedTipoTransacao && selectedTipoTransacao.key == 'E'
								&& selectedNotaEspecie && selectedNotaEspecie.key == 'R'
								|| selectedTipoTransacao && selectedTipoTransacao.key == 'S'
								&& selectedNotaEspecie && selectedNotaEspecie.key == 'R'" class="col-md-2 mb-2">
								<label for="estoque">Estoque de Materias: *</label>
								<span class="p-fluid">
									<Dropdown id="estoque" v-model="selectedEstoque" :options="estoqueMateriais"
										optionLabel="name" placeholder="Selecione uma Opção" />
								</span>
							</div>
						</div>

						<div class="row">
							<div v-if="selectedObras &&
								selectedTipoTransacao && selectedTipoTransacao.key == 'S'
								&& selectedNotaEspecie && selectedNotaEspecie.key == 'R'
								&& selectedEstoque && selectedEstoque.key == 'N'" class="col-md-3 mb-2">
								<label for="obra">Obra Destino: *</label>
								<span class="p-fluid">
									<AutoComplete id="obra" v-model="selectedObrasDirecionamento" :dropdown="true"
										:suggestions="filteredObrasDirecionamento"
										@complete="searchObrasDirecionamento($event)" field="numeroCeiAndNomeObra"
										placeholder="Pesquisar">
										<template #item="slotProps">
											<div class="p-fluid" style="max-width: 50vw">
												{{ slotProps.item.numeroCei }} - {{ slotProps.item.nome }}
											</div>
										</template>
									</AutoComplete>
								</span>
							</div>

							<div v-if="selectedObrasDirecionamento &&
								selectedTipoTransacao && selectedTipoTransacao.key == 'S'
								&& selectedNotaEspecie && selectedNotaEspecie.key == 'R'
								&& selectedEstoque && selectedEstoque.key == 'N'" class="col-md-2 mb-2">
								<label for="saldoDispon">Saldo Disponível:</label>
								<span class="p-fluid">
									<money id="saldoDispon" name="saldoDispon"
										v-model="selectedObrasDirecionamento.saldoDisponivel" v-bind="money"
										class="p-inputtext input-right" disabled></money>
								</span>
							</div>

							<div v-if="selectedObrasDirecionamento &&
								selectedTipoTransacao && selectedTipoTransacao.key == 'S'
								&& selectedNotaEspecie && selectedNotaEspecie.key == 'R'
								&& selectedEstoque && selectedEstoque.key == 'N'" class="col-md-2 mb-2">
								<label for="saldoDeduz">Saldo Deduzido:</label>
								<span class="p-fluid">
									<money id="saldoDeduz" name="saldoDeduz"
										v-model="selectedObrasDirecionamento.saldoDeduzido" v-bind="money"
										class="p-inputtext input-right" disabled></money>
								</span>
							</div>

							<div v-if="selectedObras &&
								selectedTipoTransacao && selectedTipoTransacao.key == 'E'
								&& selectedNotaEspecie && selectedNotaEspecie.key == 'R'
								&& selectedEstoque && selectedEstoque.key == 'N'" class="col-md-3 mb-2">
								<label for="obraOrigem">Obra Origem: *</label>
								<span class="p-fluid">
									<AutoComplete id="obraOrigem" v-model="selectedObrasDirecionamento" :dropdown="true"
										:suggestions="filteredObrasDirecionamento"
										@complete="searchObrasDirecionamento($event)" field="numeroCeiAndNomeObra"
										placeholder="Pesquisar">
										<template #item="slotProps">
											<div class="p-fluid" style="max-width: 50vw">
												{{ slotProps.item.numeroCei }} - {{ slotProps.item.nome }}
											</div>
										</template>
									</AutoComplete>
								</span>
							</div>

							<div v-if="selectedObrasDirecionamento &&
								selectedTipoTransacao && selectedTipoTransacao.key == 'E'
								&& selectedNotaEspecie && selectedNotaEspecie.key == 'R'
								&& selectedEstoque && selectedEstoque.key == 'N'" class="col-md-2 mb-2">
								<label for="saldoDispon">Saldo Disponível:</label>
								<span class="p-fluid">
									<money id="saldoDispon" name="saldoDispon"
										v-model="selectedObrasDirecionamento.saldoDisponivel" v-bind="money"
										class="p-inputtext input-right" disabled></money>
								</span>
							</div>

							<div v-if="selectedObrasDirecionamento &&
								selectedTipoTransacao && selectedTipoTransacao.key == 'E'
								&& selectedNotaEspecie && selectedNotaEspecie.key == 'R'
								&& selectedEstoque && selectedEstoque.key == 'N'" class="col-md-2 mb-2">
								<label for="saldoDeduz">Saldo Deduzido:</label>
								<span class="p-fluid">
									<money id="saldoDeduz" name="saldoDeduz"
										v-model="selectedObrasDirecionamento.saldoDeduzido" v-bind="money"
										class="p-inputtext input-right" disabled></money>
								</span>
							</div>
						</div>


						<div class="row">
							<div class="col-md-2 mb-2">
								<label for="nome">Número Nota: *</label>
								<span class="p-fluid">
									<InputText type="text" id="nome" v-model="transferencias.notaNumero"
										:class="{ 'p-error': validation.hasError('transferencias.notaNumero') }" />
								</span>
							</div>

							<div class="col-md-2 mb-2">
								<label for="nome">Série Nota: *</label>
								<span class="p-fluid">
									<InputText type="text" id="nome" v-model="transferencias.notaSerie"
										:class="{ 'p-error': validation.hasError('transferencias.notaSerie') }" />
								</span>
							</div>

							<div class="col-md-2 mb-2">
								<label for="notaDataEmissao">Data Emissão Nota: *</label>
								<span class="p-fluid">
									<Calendar id="notaDataEmissao" name="notaDataEmissao"
										v-model="transferencias.notaDataEmissao"
										:class="{ 'p-error': validation.hasError('transferencias.notaDataEmissao') }"
										:showIcon="true" dateFormat="dd/mm/yy" />
								</span>
							</div>
						</div>

						<div class="row">
							<div class="col-md-2 mb-2">
								<label for="valorDedut">Nota Valor Dedutível:</label>
								<span class="p-fluid">
									<money id="valorDedut" name="valorDedut" v-model="transferencias.notaValorDedutivel"
										:class="{ 'p-error': validation.hasError('transferencias.notaValorDedutivel') }"
										v-bind="money" class="p-inputtext input-right"></money>
								</span>
							</div>
						</div>

						<div class="row">
							<div class="col-md-10 mb-2">
								<label>Selecionar abaixo um arquivo, caso queira anexar ao registro:</label>
								<br />
								<span class="p-fluid">
									<input type="file" id="files" ref="files" v-on:change="handleFileUploads()" />
								</span>
							</div>
						</div>

						<hr />
						<template>
							<Button label="Gravar" title="Gravar" type="submit" v-if="!transferencias.id"
								class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading">
							</Button>
							<router-link to="/transferenciasConsulta">
								<Button label="Voltar" title="Voltar" type="button" class="p-button-primary mr-2"
									icon="pi pi-arrow-left" :disabled="loading"></Button>
							</router-link>
							<Button label="Anexos" title="Anexos" @click="visualizarAnexo(transferencias.id)"
								class="p-button-primary mr-2 p-button-success" icon="pi pi-download" :disabled="loading" v-if="transferencias.id">
							</Button>
						</template>
					</form>
				</div>
			</div>
		</div>
		<Dialog header="Anexo" :visible.sync="displayAnexos" :style="{ width: '35vw' }" :modal="true">
			<DataTable :value="anexos" :paginator="true" :rows="10" :autoLayout="true" style="min-width: 100%">
				<template #empty>Nenhum anexo encontrado.</template>
				<Column headerStyle="width: 2.5em" header bodyStyle="text-align: center">
					<template #body="slotProps">
						<Button type="button" title="Download" class="p-button-primary mr-2" icon="pi pi-download"
							style="margin-right: 0.5em" @click="
								downloadArquivo(
									slotProps.data.id,
									slotProps.data.tipoArquivo,
									slotProps.data.nomeArquivo,
								)
								" :disabled="loading"></Button>
					</template>
				</Column>
				<Column field="nomeArquivo" header="Arquivo" bodyStyle="text-align:right"></Column>
			</DataTable>
			<template #footer>
				<Button label="Fechar" icon="pi pi-times" @click="displayAnexos = false" class="p-button-danger" />
			</template>
		</Dialog>
	</div>
</template>

<script>
import money from "../conf/config.money";
import LoginService from "../services/acesso/login.service";
import Transferencias from "../models/obras/Transferencias";
import transferenciasService from "../services/obras/transferencias.service";
import SimpleVueValidation from "simple-vue-validator";
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'TransferenciasCadastro',
	data() {
		return {
			loading: false,
			money: money,
			filtro: "",
			filteredObras: null,
			filteredFornecedor: null,
			filteredObrasDirecionamento: null,
			tiposTransacao: [
				{ name: "Entrada de Materiais Dedutiveis na Obra", key: "E" },
				{ name: "Saída de Materiais Dedutiveis na Obra", key: "S" },
			],
			notasEspecie: [
				{ name: "Aquisição de Materiais", key: "A" },
				{ name: "Remessa de Materiais", key: "R" }
			],
			estoqueMateriais: [
				{ name: "Sim", key: "S" },
				{ name: "Não", key: "N" }
			],
			selectedObras: null,
			selectedFornecedor: null,
			selectedObrasDirecionamento: null,
			selectedTipoTransacao: null,
			selectedNotaEspecie: null,
			selectedEstoque: null,
			transferencias: new Transferencias(),
			files: "",
			anexos:[],
			displayAnexos:false
		}
	},

	created() {
		this.currentUser = LoginService.currentUserValue;
		this.id = this.$route.params.idTransferencias;

		if (this.id != null) {
			setTimeout(async () => {
				await transferenciasService.getTransferencias(this.id).then(
					response => {
						this.transferencias = response.data;
						this.selectedEstoque = this.estoqueMateriais.filter(
							(materiais) => materiais.key == this.transferencias.estoque
						)[0];
						this.selectedTipoTransacao = this.tiposTransacao.filter(
							(transacaoTipo) => transacaoTipo.key == this.transferencias.transacao
						)[0];
						this.selectedNotaEspecie = this.notasEspecie.filter(
							(especie) => especie.key == this.transferencias.notaEspecie
						)[0];
						this.selectedObras = this.transferencias.idObras;
						this.selectedObrasDirecionamento = this.transferencias.idObraDestino;
						this.selectedFornecedor = this.transferencias.idContribFornecedor;
						this.transferencias.notaDataEmissao = this.moment(this.transferencias.notaDataEmissao).format("DD/MM/YYYY");
					},
					error => {
						let errorMessage = "Houve um problema ao buscar a Transferência!";
						if (error.response) {
							errorMessage = error.response.data;
						}
						this.$toast.add({
							severity: "error",
							summary: errorMessage
						});
					}
				)
			}, 250);
		}
	},

	methods: {
		handleFileUploads() {
			this.files = this.$refs.files.files;
		},
		onSubmit() {
			this.loading = true;
			this.$validate().then((success) => {
				if (success) {
					this.salvar();
				}
			});
			this.loading = false;
		},

		getBase64(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => resolve(reader.result);
				reader.onerror = error => reject(error);
			});
		},

		salvar() {
			if (this.files && this.files[0]) {
				var fileSize = this.files[0].size / 1024 / 1024; // in MB
				if (fileSize > 20) {
					this.$root.$emit(
						"alert:warn",
						"Este arquivo ultrapassa o limite de 20 MB!"
					);
					return;
				}
				this.processando(true);
				this.getBase64(this.files[0]).then(response => {

					let base64 = response.replace("data:", "").replace(/^.+,/, "");
					this.transferencias.file = base64;

					this.transferencias.nomeArquivo = this.files[0].name;
					this.transferencias.tipoArquivo = this.files[0].type;

					this.saveTransferencia();
				});
			} else {
				this.saveTransferencia();
			}
		},

		saveTransferencia() {
			this.processando(true);
			if (!this.selectedObras || !this.selectedObras.id) {
				this.$toast.add({
					severity: "error",
					summary: "Selecione uma Obra!"
				});
				this.processando(false);
				return;
			}
			if (!this.selectedFornecedor || !this.selectedFornecedor.id) {
				this.$toast.add({
					severity: "error",
					summary: "Selecione um Fornecedor!"
				});
				this.processando(false);
				return;
			}
			if (this.selectedObrasDirecionamento && this.selectedObras.id === this.selectedObrasDirecionamento.id) {
				this.$toast.add({
					severity: "error",
					summary: "Obra Origem ou Obra Destino não pode ser igual a Obra!"
				});
				this.processando(false);
				return;
			}

			this.transferencias.idObraDestino = this.selectedObrasDirecionamento;
			this.transferencias.idObras = this.selectedObras;
			this.transferencias.idContribFornecedor = this.selectedFornecedor;
			if (this.selectedEstoque != null) {
				this.transferencias.estoque = this.selectedEstoque.key;
			}
			this.transferencias.notaEspecie = this.selectedNotaEspecie.key;
			this.transferencias.transacao = this.selectedTipoTransacao.key;

			console.log("chegou");
			transferenciasService.saveTransferencias(this.transferencias).then(
				data => {
					console.log(data);
					this.$toast.add({
						severity: "success",
						summary: "Transferência salva com sucesso!"
					});
					this.$router.push("transferenciasConsulta");
				},
				error => {
					let errorMessage = "Houve um erro ao salvar a Transferência!";
					if (error.response) {
						errorMessage = error.response.data;
					}
					this.$toast.add({
						severity: "error",
						summary: errorMessage
					});
				}
			);
			this.processando(false);
		},
		visualizarAnexo(id) {
			this.processando(true);
			this.anexos = [];
			transferenciasService.carregarAnexosTransferencia(
				id
			).then((response) => {
				this.anexos = response.data;
				this.displayAnexos = true;
			}).then(() => {
				this.processando(false);
			});
		},
		downloadArquivo(id, type, nome) {
			this.processando(true);
			transferenciasService.downloadAnexo(
				id, type, nome
			).then(
				(data) => {
					console.log(data);
				},
				(error) => {
					this.$root.$emit("alert:warn", "Erro ao efetuar o download!");
					console.log(error);
				}
			)
				.then(() => {
					this.processando(false);
				});
		},

		searchObras(event) {
			setTimeout(async () => {
				this.filteredObras = await transferenciasService.findObrasByFiltro(
					this.currentUser.contribuinte.idContribuinte,
					event.query
				);
			}, 550);
		},

		searchObrasDirecionamento(event) {
			setTimeout(async () => {
				this.filteredObrasDirecionamento = await transferenciasService.findObrasByFiltro(
					this.currentUser.contribuinte.idContribuinte,
					event.query
				);
			}, 550);
		},

		searchFornecedor(event) {
			setTimeout(async () => {
				this.filteredFornecedor = await transferenciasService.findFornecedorByFiltro(
					this.currentUser.contribuinte.idContribuinte,
					event.query
				);
			}, 550);
		},

		alterarKeyNotaEspecie() {
			if (this.selectedTipoTransacao.key === 'S') {
				this.notasEspecie = [
					{ name: "Remessa de Materiais", key: "R" }
				]
				this.selectedNotaEspecie = "";
			} else if (this.selectedTipoTransacao.key === 'E') {
				this.notasEspecie = [
					{ name: "Aquisição de Materiais", key: "A" },
					{ name: "Remessa de Materiais", key: "R" }
				]
				this.selectedNotaEspecie = "";
			}
		},

		processando(show) {
			if (show) {
				this.loading = true;
				this.$root.$emit("loading:show");
			} else {
				this.loading = false;
				this.$root.$emit("loading:hide");
			}
		},

		limparForm() {
			this.files = "";
			this.selectedObras = null;
			this.selectedFornecedor = null;
			this.selectedTipoTransacao = null;
			this.selectedNotaEspecie = null;
			this.selectedEstoque = null;
			this.selectedObraOrigem = null;
			this.selectedObraDestino = null;
			this.transferencias.notaNumero = '';
			this.transferencias.notaSerie = '';
			this.transferencias.notaDataEmissao = '';
			this.transferencias.notaValorDedutivel = '';
		}
	},

	validators: {
		"selectedObras": function (value) {
			return Validator.value(value)
				.required("Obra Obrigatória")
				.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"selectedFornecedor": function (value) {
			return Validator.value(value)
				.required("Fornecedor Obrigatório")
				.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"selectedTipoTransacao": function (value) {
			return Validator.value(value)
				.required("Campo Transação Obrigatório")
				.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"selectedNotaEspecie": function (value) {
			return Validator.value(value)
				.required("Campo Especie Nota Obrigatório")
				.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"transferencias.notaNumero": function (value) {
			return Validator.value(value)
				.required("Número Nota Obrigatório")
				.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"transferencias.notaSerie": function (value) {
			return Validator.value(value)
				.required("Série Nota Obrigatória")
				.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"transferencias.notaDataEmissao": function (value) {
			return Validator.value(value)
				.required("Data Emissão Obrigatória")
				.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"transferencias.notaValorDedutivel": function (value) {
			return Validator.value(value)
				.required("Valor Dedutível Obrigatório")
				.maxLength(200, "Deve ser menor ou igual a 200")
		},
	}
}
</script>

<style scoped>
.p-inputtext:disabled {
	color: #a6a6a6;
	border-color: #a6a6a6;
}

textarea {
	width: 100%;
	border-radius: 12px;
}
</style>